<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>


        <div class="item">
          <span class="label">{{ $t('order.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valOrderSn"
            :placeholder="$t('order.inp.order_no')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDeviceId"
            :placeholder="$t('order.inp.device_no')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('order.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.idName" :placeholder="$t('g.enter_name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.mobile') }}</span>
          <el-input class="inp" size="small" v-model="formData.valPhone" :placeholder="$t('member.mobile')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.device_id') }}</span>
          <el-input class="inp" size="small" v-model="formData.valBatteryId"
            :placeholder="$t('device.device_id')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.exportAllExcel(0)" class="search4" type="info">{{ $t('g.export') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" style="width: 100%" @row-click="func.showDetails">
        <el-table-column prop="Id" label="ID" width="100" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="OrderSn" :label="$t('order.no')" width="200">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="80">
        </el-table-column>

        <el-table-column prop="UserInfo.Nickname" width="100" :label="$t('bill.nickname')">
        </el-table-column>
        <el-table-column prop="UserInfo.Mobile" width="120" :label="$t('member.mobile')">
        </el-table-column>
        <el-table-column prop="UserInfo.IdName" width="120" :label="$t('member.IdName')">
        </el-table-column>
        <el-table-column width="80" :label="$t('member.status')">
          <template #default="scope">
            <el-tag
              :class="scope.row.StatusStr == $t('member.statuses.success') ? 'success' : (scope.row.StatusStr == $t('member.statuses.failed') ? 'tag-fail' : 'tag-success')">
              {{ scope.row.StatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="DeviceId" width="250" :label="$t('device.no')">
        </el-table-column>
        <el-table-column prop="DeviceSiteName" width="120" :label="$t('device.site_name')">
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.BatteryId" width="240" :label="$t('member.battery_no')"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.BatterySoc" width="90" :label="$t('device.battery_soc')">
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.SlotId" width="80" :label="$t('order.slot_return')">
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.Money" width="60" :label="$t('device.deposit')">
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.OverdueFee" width="120" :label="$t('order.overdueDeduction')">
        </el-table-column>
        <el-table-column prop="ReturnOrderInfo.BatteryAhStr" width="120" label="归还电池AH">
        </el-table-column>
        <el-table-column prop="PayWayStr" width="80" :label="$t('order.back_way')">
        </el-table-column>
        <el-table-column prop="NamePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column width="150" :label="$t('order.failed_reason')" prop="ReturnOrderInfo.Result">
        </el-table-column>
        <el-table-column prop="Remark" width="80" :label="$t('order.remark')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" min-width="200" :label="$t('g.create_at')">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <!-- <div class="pagination">
      <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
        :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
      </el-pagination>
    </div> -->
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" align-center>
      <el-descriptions border column="2">
        <el-descriptions-item :label="$t('order.no')">{{ formData.curData.OrderSn }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.mobile')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Mobile
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.IdName')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.IdName
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('device.no')">
          <el-link type="primary" @click="formData.devDrawerVisible = true">{{ formData.curData.DeviceId
          }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('device.site_name')">{{ formData.curData.DeviceSiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.battery_no')">
          <el-link type="primary" @click="formData.batDrawerVisible = true">{{
            formData.curData.ReturnOrderInfo.BatteryId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.battery_status')">{{ formData.curData.ReturnOrderInfo?.UserBatIds
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.battery_soc')">{{ formData.curData.ReturnOrderInfo.BatterySoc
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.slot_return')">{{ formData.curData.ReturnOrderInfo.SlotId
        }}</el-descriptions-item>
        <el-descriptions-item label="归还电池AH">{{ formData.curData.ReturnOrderInfo.BatteryAhStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.deposit')">{{ formData.curData.ReturnOrderInfo.Money
        }}</el-descriptions-item>

        <el-descriptions-item :label="$t('order.back_way')">{{ formData.curData.PayWayStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.status')">
          <el-tag
            :class="formData.curData.StatusStr == $t('member.statuses.success') ? 'success' : (formData.curData.StatusStr == $t('member.statuses.failed') ? 'tag-fail' : 'tag-success')">
            {{ formData.curData.StatusStr }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.failed_reason')">{{ formData.curData.ReturnOrderInfo?.Result
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')">{{ formData.curData.NamePath }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.devDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <EboxList :propId="formData.curData.DeviceId"></EboxList>
    </el-drawer>
    <el-drawer v-model="formData.batDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <BatteryList :propId="formData.curData.ReturnOrderInfo.BatteryId"></BatteryList>
    </el-drawer>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserInfo.Id"></MemberList>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import { ElLoading } from 'element-plus'
import * as XLSX from 'xlsx/xlsx.mjs'
import EboxList from '@/views/ebox/list.vue'
import BatteryList from '@/views/battery/list.vue'
import MemberList from '@/views/member/list.vue'
export default {
  name: 'OrderBatteryReturn',
  components: {
    EboxList,
    BatteryList,
    MemberList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: 2
      },
      {
        label: t('member.statuses.success'),
        value: 1
      },
      {
        label: t('member.statuses.failed'),
        value: 0
      }
    ]
    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: 2,
      valTime: '',
      valTel: '',
      valOrderSn: '',
      valDeviceId: '',
      dialogDisplayVisible: false,
      devDrawerVisible: false,
      batDrawerVisible: false,
      userDrawerVisible: false,
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1
    })
    const func = {
      async exportAllExcel(type = 1) {

        let params = {
        }
        if (formData.valOrderSn) {
          params.orderSn = formData.valOrderSn
        }
        if (formData.valDeviceId) {
          params.deviceId = formData.valDeviceId
        }
        if (formData.CodePathID) {
          params.CodePathID = formData.CodePathID
        }
        if (formData.valTel) {
          params.nickname = formData.valTel
        }
        if (formData.valStatus != 2) {
          params.status = formData.valStatus
        }
        if (formData.valPhone) {
          params.phoneNum = formData.valPhone
        }
        if (formData.idName) {
          params.idName = formData.idName
        }
        if (formData.valTime) {
          params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
          params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
        }
        params.isExport = true
        params.IsStartWith = formData.IsStartWith
        let loading = ''
        loading = ElLoading.service({
          lock: true,
          text: t('openSlotsLit.loading'),
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let res = await axios.get(`/admin/order/return`, {
          params
        })
        let excleData = [[]];
        let wscols = [];
        excleData = [[
          'ID',
          t('openSlotsLit.agent_code'),
          t('openSlotsLit.site_name'),
          t('openSlotsLit.dev_id'),
          '用户Id',
          '姓名',
          '手机',
          '状态',
          '押金',
          '预计逾期扣费',
          '实际逾期扣费',
          '备注',
          '失败原因',
          t('g.create_at'),
        ]];
        wscols = [    // 每列不同宽度px
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 25 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 4 },
          { wch: 6 },
          { wch: 18 },
          { wch: 18 },
          { wch: 22 },
          { wch: 22 },
        ];
        const dictType = [
          t('openSlotsLit.types.all_slot'),
          t('openSlotsLit.types.all_empty_slot'),
          t('openSlotsLit.types.all_battery_slot'),
          t('openSlotsLit.types.Specify_slot'),
          t('openSlotsLit.types.full_charge_slot'),
        ]
        if (res && res.List) {
          for (let item of res.List) {
            let arr = [];
            item.StatusStr = item.DeviceStatus === 1 ? (item.Status == 2 ? t('order.returned') : t('member.statuses.success')) : t('member.statuses.failed')
            arr = [
              item.Id,
              item.AgentCode,
              item.DeviceSiteName,
              item.DeviceId,
              item.UserInfo?.Id,
              item.UserInfo?.IdName,
              item.UserInfo?.Mobile,
              item.StatusStr,
              item.ReturnOrderInfo?.Money,
              item.ReturnOrderInfo?.OverdueFee,
              item.ReturnOrderInfo?.RealOverdueFee,
              item.Remark,
              item.ReturnOrderInfo?.Result,
              toDay(item.CreatedAt),
            ]
            excleData.push(arr)
          }
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excleData);
        worksheet["!cols"] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        loading.close()
        XLSX.writeFile(workbook, '还电订单' + '.xlsx');
      },
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = 2
        formData.valTime = ''
        formData.valTel = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valOrderSn) {
            params.orderSn = formData.valOrderSn
          }
          if (formData.valDeviceId) {
            params.deviceId = formData.valDeviceId.trim()
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.valStatus != 2) {
            params.status = formData.valStatus
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.idName) {
            params.idName = formData.idName
          }
          if (formData.valBatteryId) {
            params.batId = formData.valBatteryId.trim()
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/order/return`, {
            params
          })
          // console.log(JSON.stringify(res));

          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.StatusStr = item.DeviceStatus === 1 ? (item.Status == 2 ? t('order.returned') : t('member.statuses.success')) : t('member.statuses.failed')
            item.PayWayStr = ""
            item.ReturnOrderInfo.BatteryAhStr = item.ReturnOrderInfo.BatteryAh / 100 + 'Ah'
            if (item.PayWay == 1) {
              item.PayWayStr = t('order.pay_ways.balance')
            } else if (item.PayWay == 2) {
              item.PayWayStr = t('order.pay_ways.wechat')
            } else if (item.PayWay == 5) {
              item.PayWayStr = t('order.pay_ways.alipay')
            }
            item.ImagePre = []
            if (!item.DevImageList) {
              item.DevImageList = []
            }
            item.DevImageList.map((item2) => {
              item2.TypeName = ""
              switch (item2.OperType) {
                case 0:
                  item2.TypeName = t('order.imgs.t0')
                  break
                case 1:
                  item2.TypeName = t('order.imgs.t1')
                  break
                case 2:
                  item2.TypeName = t('order.imgs.t2')
                  break
                case 3:
                  item2.TypeName = t('order.imgs.t3')
                  break
              }
              item.ImagePre.push(item2.Image)
            })
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 0 1.25rem;

  .inp-block {
    display: block;
  }

  .table-expand {
    padding-left: 4rem;
    padding-top: 1rem;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;
      margin-top: 12px;

      >.search1 {
        background-color: #14b2ec;
        color: #fff;
        border: 1px solid #14b2ec;
      }

      >.search2 {
        background-color: #048cbe;
        color: #fff;
        border: 1px solid #048cbe;
      }

      >.search3 {
        background-color: #ee8094;
        color: #fff;
        border: 1px solid #ee8094;
      }

      >.search4 {
        background-color: #bdb2b5;
        color: #fff;
        border: 1px solid #bdb2b5;
      }

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;
        // justify-content: left;

        .label {
          display: flex;
          justify-content: left;
          // margin-right: 0.325rem;
          // margin-left: 0.3rem;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  // >.data-table {
  //   :deep(.el-table) {
  //     .cell {
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //     }

  //     .el-table__row {
  //       cursor: pointer;
  //     }
  //   }
  // }

  .pagination {
    // text-align: right;
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;

    .title {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}

.line {
  height: 1px;
  width: 100%;
  background-color: #e2e2e2;
  margin-top: 15px;
  margin-bottom: 15px;
}

@media screen and (max-width:1300px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(3, 32.2%);
      }
    }
  }
}

@media screen and (max-width:1030px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(2, 48.8%);
      }
    }
  }
}

@media screen and (max-width:792px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(1, 100%);
      }
    }
  }
}
</style>